import React, { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'
import { alertNotification } from 'src/ui'

interface CopyButtonProps {
  value: string
  title?: string
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, title = 'Copy' }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation()
    navigator.clipboard.writeText(value)
    alertNotification('Copied to clipboard', 'success')
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Tooltip title={title}>
      <IconButton size="small" onClick={handleCopy} sx={{ p: 0.4 }}>
        {copied ? (
          <CheckIcon sx={{ fontSize: 16, color: 'success.main' }} />
        ) : (
          <ContentCopyIcon sx={{ fontSize: 16 }} />
        )}
      </IconButton>
    </Tooltip>
  )
}

export default CopyButton
